export const mapMessageData = messageData => {
    if (!messageData) return null;

    const link = messageData.Links;
    const content = messageData.Text;

    const links = Object.entries(link)
        .map(([key, value]) => ({
            from: content.indexOf(key),
            len: key.length,
            title: value,
            linkData: {
                eName: key.replace(/[{}]/g, '').split('.')[0],
                eType: key.replace(/[{}]/g, '').split('.')[1]
            }
        }))
        .sort((a, b) => (a.from < b.from ? -1 : 1));

    return {content, links};
};
